import { combineReducers } from '@reduxjs/toolkit'
import auth from "./auth/reducers";

const rootReducer = combineReducers({
    auth: auth,
})

export default rootReducer
